import React, { useEffect } from 'react';
import { styled } from '@compiled/react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { SHORTCUT_MENU_ITEM_BASE_WIDTH } from '../../constants.tsx';
import { ShortcutMenuContentEntryPoint } from './entrypoint.tsx';
import { Fallback } from './fallback/index.tsx';
import type { Props } from './types.tsx';

const entryPointParams = {};
const AsyncShortcutMenuContent = (props: Props) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		ShortcutMenuContentEntryPoint,
		entryPointParams,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<ShortcutMenuContentWrapper>
			<JiraEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="jwm.shortcut.shortcuts-menu-content"
				packageName="jiraBusinessShortcut"
				runtimeProps={props}
				fallback={<Fallback />}
			/>
		</ShortcutMenuContentWrapper>
	);
};

export default AsyncShortcutMenuContent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShortcutMenuContentWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${SHORTCUT_MENU_ITEM_BASE_WIDTH}px`,
});
